module.exports = __webpack_public_path__ + "static/media/filter.5215f44e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/games/filter.svg
// module id = 811
// module chunks = 7